export default "__VITE_ASSET__oMNyH1QQ__"